module.exports = __webpack_public_path__ + "img/avatar-s-21.3fdebd01.jpg";